import { Box, Paper } from '@mantine/core';

import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { IsiArticle } from '@/module/AnnualReport/model/AnnualReportTypes';
import { ArticleValidationAction } from '@/module/Author/Article/Validation/ArticleValidationAction';
import { ArticleCard } from '@/module/Author/Article/components/Card/ArticleCard';
import { PublicationImpactFactor } from '@/module/Journal/components/PublicationImpactFactor';

interface CollapsableArticleProps {
  title: string;
  articles: IsiArticle[];
}

export function CollapsableIsiArticle({ title, articles }: CollapsableArticleProps) {
  return (
    <CollapsableGroup
      title={title}
      items={articles}
      renderValidation={isi => (
        <ArticleValidationAction
          variant="compact"
          articleId={isi.article.id}
        />
      )}
      renderItem={isi => (
        <Paper>
          <ArticleCard
            article={isi.article}
            onClick={() => window.open(`/author/article/${isi.article.id}`)}
          />
          <Box p="sm">
            <PublicationImpactFactor data={isi.metrics} />
          </Box>
        </Paper>
      )}
    />
  );
}
